export var EmailTemplateImageRole;
(function (EmailTemplateImageRole) {
    EmailTemplateImageRole[EmailTemplateImageRole["Header"] = 1] = "Header";
    EmailTemplateImageRole[EmailTemplateImageRole["Body"] = 2] = "Body";
})(EmailTemplateImageRole || (EmailTemplateImageRole = {}));
